var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"typedSignature",style:(_vm.getFontStyle),attrs:{"id":"capture"},on:{"click":function($event){return _vm.convertHtmlToCanvas()}}},[_c('p',{ref:"canvas",staticStyle:{"padding":"2px"}},[_vm._v(_vm._s(_vm.typedSignature))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }